import { cx } from "utils";


export default function RecommendedBadge({ className = "" }: { className?: string }) {
  return (
    <div
      className={ cx("flex h-[22px] items-center justify-center gap-1 px-1.5 bg-accent-100 text-accent-800 text-[11px] font-normal leading-4 rounded-sm", className) }
    >
      Recommended
    </div>
  );
}
